import React from "react";
export default (function (_ref) {
  var children = _ref.children,
    config = _ref.config;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
});